import { ArrowLeft, ArrowRight, Check, CreditCard } from "lucide-react"
import { useLeadStore } from "../../stores/use-lead-store"
import { Button } from "../ui/button"

interface WidgetActionsProps {
	isPreview: boolean
	isFirstStage: boolean
	isLastStage: boolean
	handlePrevious?: () => void
	handleNext?: () => void
	isSubmitting: boolean
	isSubmitted: boolean
	submitTypeRef: React.RefObject<
		"enquire" | "apply" | "leadPunch" | "referral"
	>
	isLeadPunch: boolean
	isReferralWidget: boolean
	isDisabled?: boolean
}

export const WidgetActions = ({
	isPreview = true,
	isFirstStage = true,
	isLastStage = true,
	handleNext,
	handlePrevious,
	isSubmitting = false,
	isSubmitted = false,
	submitTypeRef,
	isLeadPunch,
	isReferralWidget,
	isDisabled = false,
}: WidgetActionsProps) => {
	const { status } = useLeadStore()
	if (isLeadPunch) {
		return (
			<div className="flex justify-end">
				<Button
					disabled={!status || isDisabled}
					type="submit"
					name="leadPunch"
					onClick={() => {
						submitTypeRef.current = "leadPunch"
					}}
					size={"lg"}
				>
					Create Lead
				</Button>
			</div>
		)
	}

	if (isReferralWidget) {
		return (
			<div className="flex justify-center">
				<Button
					disabled={!status || isDisabled}
					type="submit"
					name="referral"
					onClick={() => {
						submitTypeRef.current = "referral"
					}}
					size={"lg"}
				>
					Send Invitation
				</Button>
			</div>
		)
	}

	return (
		<div className="flex flex-col items-center justify-between gap-4 @xl:flex-row">
			{isFirstStage && (
				<Button
					disabled={isPreview || !status || isDisabled}
					type="submit"
					name="enquire"
					onClick={() => (submitTypeRef.current = "enquire")}
					size={"lg"}
				>
					Enquire Now
				</Button>
			)}

			{!isFirstStage && (
				<Button
					type="button"
					variant="outline"
					onClick={handlePrevious}
					disabled={isSubmitting || isDisabled}
					className="gap-2 bg-transparent"
					size={"lg"}
				>
					<ArrowLeft className="h-4 w-4" />
					Previous Step
				</Button>
			)}

			{!isLastStage && (
				<Button
					type={isPreview ? "button" : "submit"}
					onClick={() => {
						if (isPreview) {
							handleNext?.()
						}
					}}
					className="gap-2"
					size="lg"
					disabled={!status || isDisabled}
				>
					<>
						Next Step
						<ArrowRight className="h-4 w-4" />
					</>
				</Button>
			)}

			{isLastStage && (
				<Button
					type="submit"
					disabled={
						isPreview ||
						isSubmitting ||
						isSubmitted ||
						!status ||
						isDisabled
					}
					className="gap-2"
					size="lg"
					onClick={() => (submitTypeRef.current = "apply")}
				>
					{isSubmitting ? (
						<>
							<div className="h-4 w-4 animate-spin rounded-full border-b-2 border-white" />
							Applying...
						</>
					) : isSubmitted ? (
						<>
							<Check className="h-4 w-4" />
							Applied
						</>
					) : (
						<>
							<CreditCard className="h-4 w-4" />
							Apply Now
						</>
					)}
				</Button>
			)}
		</div>
	)
}
